{
  "factory": [
    {
      "name": "Camera Bunker Door",
      "faction": "scav",
      "lat": 40.11,
      "lng": -15.72
    },
    {
      "name": "Cellars",
      "faction": "pmc",
      "lat": -29.08,
      "lng": 73.89
    },
    {
      "name": "Courtyard Gate",
      "faction": "pmc",
      "lat": 68.94,
      "lng": 23.76
    },
    {
      "name": "Gate 0",
      "faction": "pmc",
      "lat": 55.88,
      "lng": -63.67
    },
    {
      "name": "Gate 2",
      "faction": "pmc",
      "lat": -53.48,
      "lng": 44.89
    },
    {
      "name": "Gate 3",
      "faction": "shared",
      "lat": 60.87,
      "lng": 58.71
    },
    {
      "name": "Med Tent Gate",
      "faction": "pmc",
      "lat": -61.27,
      "lng": -17.53
    },
    {
      "name": "Office Window",
      "faction": "scav",
      "lat": 39.89,
      "lng": 17.83
    },
    {
      "name": "Smugglers' Passage",
      "faction": "pmc",
      "lat": -28.86,
      "lng": 48.03
    },
    {
      "name": "Transit to Customs",
      "faction": "transit",
      "lat": -49.62,
      "lng": 17.34
    },
    {
      "name": "Transit to The Lab",
      "faction": "transit",
      "lat": -42.75,
      "lng": -27.01
    },
    {
      "name": "Transit to Woods",
      "faction": "transit",
      "lat": 60.22,
      "lng": 24.36
    }
  ],
  "customs": [
    {
      "name": "Administration Gate",
      "faction": "scav",
      "lat": -55.33,
      "lng": 664.71
    },
    {
      "name": "Boiler Room Basement (Co-op)",
      "faction": "coop",
      "lat": -44.42,
      "lng": 100.56
    },
    {
      "name": "Crossroads",
      "faction": "shared",
      "lat": -87.98,
      "lng": -334.8
    },
    {
      "name": "Dorms V-Ex",
      "faction": "pmc",
      "lat": 213.25,
      "lng": 181.08
    },
    {
      "name": "Factory Far Corner",
      "faction": "scav",
      "lat": -160.49,
      "lng": 652.45
    },
    {
      "name": "Factory Shacks",
      "faction": "scav",
      "lat": 3.31,
      "lng": 205.59
    },
    {
      "name": "Military Base CP",
      "faction": "scav",
      "lat": 126.87,
      "lng": 644.88
    },
    {
      "name": "Old Gas Station",
      "faction": "pmc",
      "lat": -174.32,
      "lng": 309.5
    },
    {
      "name": "Old Gas Station Gate",
      "faction": "scav",
      "lat": -198.52,
      "lng": 300.51
    },
    {
      "name": "Old Road Gate",
      "faction": "scav",
      "lat": 214.01,
      "lng": 181.77
    },
    {
      "name": "Passage Between Rocks",
      "faction": "scav",
      "lat": 200.34,
      "lng": 539.39
    },
    {
      "name": "Railroad Passage (Flare)",
      "faction": "pmc",
      "lat": -324.62,
      "lng": 139.13
    },
    {
      "name": "Railroad to Military Base",
      "faction": "scav",
      "lat": 221.39,
      "lng": 489.06
    },
    {
      "name": "Railroad to Port",
      "faction": "scav",
      "lat": 46.68,
      "lng": -149.11
    },
    {
      "name": "Railroad to Tarkov",
      "faction": "scav",
      "lat": -217.45,
      "lng": -163.47
    },
    {
      "name": "RUAF Roadblock",
      "faction": "shared",
      "lat": -138.45,
      "lng": -10.25
    },
    {
      "name": "Scav Checkpoint",
      "faction": "scav",
      "lat": -27.42,
      "lng": 652.08
    },
    {
      "name": "Smugglers' Boat",
      "faction": "pmc",
      "lat": 122.67,
      "lng": -41.51
    },
    {
      "name": "Smugglers' Bunker (ZB-1012)",
      "faction": "pmc",
      "lat": -112.36,
      "lng": 463.18
    },
    {
      "name": "Sniper Roadblock",
      "faction": "scav",
      "lat": 126.29,
      "lng": 15.08
    },
    {
      "name": "Trailer Park",
      "faction": "pmc",
      "lat": -233.28,
      "lng": -313.72
    },
    {
      "name": "Trailer Park Workers' Shack",
      "faction": "scav",
      "lat": -232.99,
      "lng": -248.54
    },
    {
      "name": "Transit to Factory",
      "faction": "transit",
      "lat": -190.1,
      "lng": 354.31
    },
    {
      "name": "Transit to Interchange",
      "faction": "transit",
      "lat": -211.95,
      "lng": -334.22
    },
    {
      "name": "Transit to Reserve",
      "faction": "transit",
      "lat": 124.94,
      "lng": 650.64
    },
    {
      "name": "Transit to Shoreline",
      "faction": "transit",
      "lat": 139.61,
      "lng": 20.94
    },
    {
      "name": "Warehouse 17",
      "faction": "scav",
      "lat": -69.82,
      "lng": 50.74
    },
    {
      "name": "Warehouse 4",
      "faction": "scav",
      "lat": -25.85,
      "lng": 341.57
    },
    {
      "name": "ZB-013",
      "faction": "pmc",
      "lat": -153.09,
      "lng": 200.98
    },
    {
      "name": "ZB-1011",
      "faction": "pmc",
      "lat": -128.6,
      "lng": 621.5
    }
  ],
  "woods": [
    {
      "name": "Boat",
      "faction": "scav",
      "lat": 215.86,
      "lng": 176.64
    },
    {
      "name": "Bridge V-Ex",
      "faction": "pmc",
      "lat": -504.06,
      "lng": -485.33
    },
    {
      "name": "Dead Man's Place",
      "faction": "scav",
      "lat": 259.21,
      "lng": 195.55
    },
    {
      "name": "Eastern Rocks",
      "faction": "scav",
      "lat": -35.33,
      "lng": -509.36
    },
    {
      "name": "Mountain Stash",
      "faction": "scav",
      "lat": -213.5,
      "lng": -210.33
    },
    {
      "name": "Northern UN Roadblock",
      "faction": "pmc",
      "lat": -67.05,
      "lng": -557.32
    },
    {
      "name": "Old Railway Depot",
      "faction": "scav",
      "lat": 149.19,
      "lng": -517.93
    },
    {
      "name": "Outskirts",
      "faction": "shared",
      "lat": 358.58,
      "lng": 349.04
    },
    {
      "name": "Power Line Passage (Flare)",
      "faction": "pmc",
      "lat": -85.26,
      "lng": 573.99
    },
    {
      "name": "Railway Bridge to Tarkov",
      "faction": "pmc",
      "lat": 129.32,
      "lng": -730.43
    },
    {
      "name": "RUAF Gate",
      "faction": "pmc",
      "lat": 447.58,
      "lng": -142.5
    },
    {
      "name": "RUAF Roadblock",
      "faction": "scav",
      "lat": 422.4,
      "lng": -142.25
    },
    {
      "name": "Scav Bunker",
      "faction": "scav",
      "lat": -705.8,
      "lng": 220.43
    },
    {
      "name": "Scav House",
      "faction": "scav",
      "lat": 242.17,
      "lng": 413.69
    },
    {
      "name": "Transit to Customs",
      "faction": "transit",
      "lat": 403.41,
      "lng": -150.37
    },
    {
      "name": "Transit to Factory",
      "faction": "transit",
      "lat": 361.18,
      "lng": -362.05
    },
    {
      "name": "Transit to Lighthouse",
      "faction": "transit",
      "lat": 348.29,
      "lng": 496.04
    },
    {
      "name": "Transit to Reserve",
      "faction": "transit",
      "lat": 362.62,
      "lng": 254.29
    },
    {
      "name": "UN Roadblock",
      "faction": "shared",
      "lat": 287.05,
      "lng": -535.24
    },
    {
      "name": "ZB-014",
      "faction": "pmc",
      "lat": 57.46,
      "lng": 447.24
    },
    {
      "name": "ZB-016",
      "faction": "pmc",
      "lat": 11.04,
      "lng": -389.16
    }
  ],
  "lighthouse": [
    {
      "name": "Armored Train",
      "faction": "shared",
      "lat": -869.48,
      "lng": 6.27
    },
    {
      "name": "Mountain Pass",
      "faction": "pmc",
      "lat": -6.39,
      "lng": -172.35
    },
    {
      "name": "Northern Checkpoint",
      "faction": "pmc",
      "lat": -989.23,
      "lng": 113.22
    },
    {
      "name": "Passage by the Lake",
      "faction": "pmc",
      "lat": -564.87,
      "lng": -360
    },
    {
      "name": "Path to Shoreline",
      "faction": "shared",
      "lat": -121.4,
      "lng": -364.4
    },
    {
      "name": "Scav Hideout at the Grotto",
      "faction": "scav",
      "lat": -485.94,
      "lng": 180.66
    },
    {
      "name": "Southern Road Landslide",
      "faction": "scav",
      "lat": 420.8,
      "lng": -281.3
    },
    {
      "name": "Transit to Reserve",
      "faction": "transit",
      "lat": -779.99,
      "lng": -291.79
    },
    {
      "name": "Transit to Shoreline",
      "faction": "transit",
      "lat": -165.53,
      "lng": -338.35
    },
    {
      "name": "Transit to Woods",
      "faction": "transit",
      "lat": -957.12,
      "lng": 108.93
    }
  ],
  "shoreline": [
    {
      "name": "Admin Basement",
      "faction": "scav",
      "lat": -149.78,
      "lng": -256.87
    },
    {
      "name": "CCP Temporary",
      "faction": "pmc",
      "lat": 476.82,
      "lng": -855.85
    },
    {
      "name": "Cliff Descent",
      "faction": "pmc",
      "lat": -360.04,
      "lng": -196.08
    },
    {
      "name": "Climber's Trail",
      "faction": "pmc",
      "lat": -361.8,
      "lng": -214.3
    },
    {
      "name": "East Wing Gym Entrance",
      "faction": "scav",
      "lat": -100.89,
      "lng": -296.95
    },
    {
      "name": "Lighthouse",
      "faction": "scav",
      "lat": 567.29,
      "lng": -458.15
    },
    {
      "name": "Mountain Bunker",
      "faction": "pmc",
      "lat": -385.72,
      "lng": -390.96
    },
    {
      "name": "Path to Lighthouse",
      "faction": "pmc",
      "lat": -254.6,
      "lng": 448.9
    },
    {
      "name": "Pier Boat",
      "faction": "pmc",
      "lat": 564.14,
      "lng": -335.89
    },
    {
      "name": "Road to Customs",
      "faction": "shared",
      "lat": 0.49,
      "lng": -859.05
    },
    {
      "name": "Road to North V-Ex",
      "faction": "pmc",
      "lat": -378.59,
      "lng": -543.13
    },
    {
      "name": "Rock Passage",
      "faction": "pmc",
      "lat": -358.34,
      "lng": -200.8
    },
    {
      "name": "Ruined House Fence",
      "faction": "scav",
      "lat": -66.83,
      "lng": 477.78
    },
    {
      "name": "Ruined Road",
      "faction": "scav",
      "lat": 332.51,
      "lng": 366.62
    },
    {
      "name": "Smugglers' Path (Co-op)",
      "faction": "coop",
      "lat": -255.1,
      "lng": -729.4
    },
    {
      "name": "Svetliy Dead End",
      "faction": "scav",
      "lat": 120.6,
      "lng": 461.36
    },
    {
      "name": "Transit to Icebreaker",
      "faction": "transit",
      "lat": 525.71,
      "lng": -315.7
    },
    {
      "name": "Transit to Lighthouse",
      "faction": "transit",
      "lat": -214.15,
      "lng": 416.78
    },
    {
      "name": "Transit to Terminal",
      "faction": "transit",
      "lat": 373.79,
      "lng": -965.56
    },
    {
      "name": "Transit to The Labyrinth",
      "faction": "transit",
      "lat": -82.93,
      "lng": -195.13
    },
    {
      "name": "Tunnel",
      "faction": "pmc",
      "lat": 319.25,
      "lng": 376.36
    }
  ],
  "reserve": [
    {
      "name": "Bunker Hermetic Door",
      "faction": "shared",
      "lat": -190.54,
      "lng": 61.92
    },
    {
      "name": "Checkpoint Fence",
      "faction": "scav",
      "lat": 134.31,
      "lng": 61.97
    },
    {
      "name": "Cliff Descent",
      "faction": "pmc",
      "lat": 208.43,
      "lng": -9.24
    },
    {
      "name": "Depot Hermetic Door",
      "faction": "scav",
      "lat": -120.35,
      "lng": 120.78
    },
    {
      "name": "Exit to Woods",
      "faction": "pmc",
      "lat": -221.56,
      "lng": 36.53
    },
    {
      "name": "Heating Pipe",
      "faction": "scav",
      "lat": -180.12,
      "lng": -35.26
    },
    {
      "name": "Hole in the Wall by the Mountains",
      "faction": "scav",
      "lat": 48.52,
      "lng": -261.43
    },
    {
      "name": "Scav Lands (Co-Op)",
      "faction": "coop",
      "lat": -142.59,
      "lng": -127.9
    },
    {
      "name": "Sewer Manhole",
      "faction": "shared",
      "lat": 76.45,
      "lng": 40.18
    },
    {
      "name": "Transit to Customs",
      "faction": "transit",
      "lat": -115.66,
      "lng": -195.85
    },
    {
      "name": "Transit to Lighthouse",
      "faction": "transit",
      "lat": -124.28,
      "lng": 238.75
    },
    {
      "name": "Transit to Woods",
      "faction": "transit",
      "lat": -202.36,
      "lng": 215.99
    }
  ],
  "interchange": [
    {
      "name": "Emercom Checkpoint",
      "faction": "shared",
      "lat": 266.74,
      "lng": -321.56
    },
    {
      "name": "Hole in the Fence",
      "faction": "pmc",
      "lat": -37.02,
      "lng": -219.92
    },
    {
      "faction": "pmc",
      "lat": -175.11,
      "lng": -138.53
    },
    {
      "name": "Power Station V-Ex",
      "faction": "pmc",
      "lat": -367.73,
      "lng": -302.89
    },
    {
      "name": "Railway Exfil",
      "faction": "shared",
      "lat": -433.74,
      "lng": 474.57
    },
    {
      "name": "Saferoom Exfil",
      "faction": "pmc",
      "lat": 44.06,
      "lng": -47.73
    },
    {
      "name": "Scav Camp (Co-Op)",
      "faction": "coop",
      "lat": -73.09,
      "lng": -97.48
    },
    {
      "faction": "pmc",
      "lat": 71.3,
      "lng": 613.9
    },
    {
      "name": "Transit to Customs",
      "faction": "transit",
      "lat": 435.08,
      "lng": 280.26
    },
    {
      "name": "Transit to Streets of Tarkov",
      "faction": "transit",
      "lat": -453.65,
      "lng": 271.85
    }
  ],
  "streets-of-tarkov": [
    {
      "name": "Basement Entrance",
      "faction": "scav",
      "lat": 243.8,
      "lng": -249.01
    },
    {
      "name": "Cardinal Apartment Complex Parking",
      "faction": "scav",
      "lat": -161.17,
      "lng": 104.84
    },
    {
      "name": "Collapsed Crane",
      "faction": "pmc",
      "lat": 272.7,
      "lng": 216.12
    },
    {
      "name": "Courtyard",
      "faction": "pmc",
      "lat": 500.13,
      "lng": -150.51
    },
    {
      "name": "Crash Site",
      "faction": "pmc",
      "lat": 405.96,
      "lng": 312.74
    },
    {
      "name": "Damaged House",
      "faction": "pmc",
      "lat": 344.82,
      "lng": -245.41
    },
    {
      "name": "Entrance to Catacombs",
      "faction": "scav",
      "lat": 243.8,
      "lng": -249.01
    },
    {
      "name": "Expo Checkpoint",
      "faction": "pmc",
      "lat": -104.96,
      "lng": 213.12
    },
    {
      "name": "Klimov Shopping Mall Exfil",
      "faction": "scav",
      "lat": -5.66,
      "lng": -163.82
    },
    {
      "name": "Klimov Street (Flare)",
      "faction": "pmc",
      "lat": 43.19,
      "lng": -263.41
    },
    {
      "name": "Near Kamchatskaya Arch",
      "faction": "scav",
      "lat": 48.72,
      "lng": 259.57
    },
    {
      "name": "Pinewood Basement (Co-Op)",
      "faction": "coop",
      "lat": 64.88,
      "lng": -114.28
    },
    {
      "name": "Primorsky Ave Taxi V-Ex",
      "faction": "pmc",
      "lat": 461.23,
      "lng": -2.19
    },
    {
      "name": "Scav Checkpoint",
      "faction": "pmc",
      "lat": 82.31,
      "lng": 211.34
    },
    {
      "name": "Sewer Manhole",
      "faction": "scav",
      "lat": 345.39,
      "lng": 276.11
    },
    {
      "name": "Sewer River",
      "faction": "pmc",
      "lat": 219.48,
      "lng": -267.04
    },
    {
      "name": "Smugglers' Basement",
      "faction": "pmc",
      "lat": 50.01,
      "lng": 75.99
    },
    {
      "name": "Stylobate Building Elevator",
      "faction": "pmc",
      "lat": -72.15,
      "lng": -44.74
    },
    {
      "name": "Transit to Ground Zero",
      "faction": "transit",
      "lat": 104.69,
      "lng": -258.04
    },
    {
      "name": "Transit to Interchange",
      "faction": "transit",
      "lat": 501.98,
      "lng": 290.55
    },
    {
      "name": "Transit to The Lab",
      "faction": "transit",
      "lat": 82.4,
      "lng": 209.52
    },
    {
      "name": "Ventilation Shaft",
      "faction": "scav",
      "lat": 423.93,
      "lng": -124.13
    }
  ],
  "the-lab": [
    {
      "name": "Cargo Elevator",
      "faction": "shared",
      "lat": -408.55,
      "lng": -111.79
    },
    {
      "name": "Hangar Gate",
      "faction": "pmc",
      "lat": -218.87,
      "lng": -170.49
    },
    {
      "name": "Main Elevator",
      "faction": "shared",
      "lat": -334.73,
      "lng": -282.69
    },
    {
      "name": "Parking Gate",
      "faction": "pmc",
      "lat": -457.77,
      "lng": -231.46
    },
    {
      "name": "Sewage Conduit",
      "faction": "pmc",
      "lat": -258.32,
      "lng": -122.89
    },
    {
      "name": "Transit to Streets of Tarkov",
      "faction": "transit",
      "lat": -420.56,
      "lng": -170.14
    },
    {
      "name": "Ventilation Shaft",
      "faction": "pmc",
      "lat": -396.83,
      "lng": -145.06
    }
  ],
  "ground-zero": [
    {
      "name": "Emercom Checkpoint",
      "faction": "shared",
      "lat": -97.46,
      "lng": 151.63
    },
    {
      "name": "Mira Ave (Flare)",
      "faction": "pmc",
      "lat": -38.51,
      "lng": 218.23
    },
    {
      "name": "Nakatani Basement Stairs",
      "faction": "shared",
      "lat": 335.06,
      "lng": -16.12
    },
    {
      "name": "Pinewood Basement (Co-Op)",
      "faction": "shared",
      "lat": 65.63,
      "lng": -113.71
    },
    {
      "name": "Police Cordon V-Ex",
      "faction": "pmc",
      "lat": 114.94,
      "lng": -19.51
    },
    {
      "name": "Scav Bunker",
      "faction": "scav",
      "lat": -705.8,
      "lng": 220.43
    },
    {
      "name": "Scav Checkpoint (Co-op)",
      "faction": "coop",
      "lat": -79.54,
      "lng": 25.22
    },
    {
      "name": "Tartowers Sales Office",
      "faction": "pmc",
      "lat": 133.39,
      "lng": 190.8
    },
    {
      "name": "Transit to Streets of Tarkov",
      "faction": "transit",
      "lat": 65.36,
      "lng": 229.6
    },
    {
      "name": "UN Roadblock",
      "faction": "pmc",
      "lat": 288.23,
      "lng": -527.87
    }
  ],
  "the-labyrinth": [
    {
      "faction": "pmc",
      "lat": 40.13,
      "lng": -7.31
    },
    {
      "faction": "pmc",
      "lat": 0.5,
      "lng": 19.44
    }
  ]
}
